import { FC } from 'react'
import { Box } from '@mui/material'
import { SubscriptionRow } from '@/components/auto-report-dialog/subscription-row.tsx'

type SubscriptionsListType = {
  items: Array<{ id: number; email: string; isDelete: boolean; format: string; frequency: string }>
  onDelete: (id: number, email: string) => void
  onReturn: (id: number, email: string) => void
}

export const SubscriptionsList: FC<SubscriptionsListType> = ({ items, onReturn, onDelete }) => {
  return (
    <Box
      sx={{
        gap: `8px`,
        display: 'flex',
        justifyContent: 'flex-start',
        flexDirection: 'column',
        maxHeight: '35vh',
        overflowY: 'scroll',
        boxSizing: 'border-box',
      }}
    >
      {items.map((e) => (
        <SubscriptionRow key={`${e.id}_${e.email}`} onDelete={onDelete} onReturn={onReturn} {...e} />
      ))}
    </Box>
  )
}
